var _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgApplicationStatusCheckIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "check",
    id: "Group_23739",
    "data-name": "Group 23739",
    xmlns: "http://www.w3.org/2000/svg",
    width: 47.889,
    height: 47.89,
    viewBox: "0 0 47.889 47.89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_23811",
    "data-name": "Group 23811"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22769",
    "data-name": "Path 22769",
    d: "M2.993,16H35.918a2.993,2.993,0,0,1,2.993,2.993V59.4a2.993,2.993,0,0,1-2.993,2.993H2.993A2.993,2.993,0,0,1,0,59.4V18.993A2.993,2.993,0,0,1,2.993,16",
    transform: "translate(0 -14.503)",
    fill: "#343d63"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22770",
    "data-name": "Path 22770",
    d: "M32,78.551V48H64.924V88.407H41.856Z",
    transform: "translate(-29.008 -43.51)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22771",
    "data-name": "Path 22771",
    d: "M41.856,374.625v9.856L32,374.625Z",
    transform: "translate(-29.008 -339.584)",
    fill: "#343d63"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22772",
    "data-name": "Path 22772",
    d: "M128,5.986V0h14.966V5.986a2.993,2.993,0,0,1-2.993,2.993h-8.979A2.993,2.993,0,0,1,128,5.986",
    transform: "translate(-116.027)",
    fill: "#343d63"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22775",
    "data-name": "Path 22775",
    d: "M161.5,128h11.973a1.5,1.5,0,0,1,0,2.993H161.5a1.5,1.5,0,1,1,0-2.993",
    transform: "translate(-145.035 -116.028)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3795",
    "data-name": "Rectangle 3795",
    width: 2.043,
    height: 2.043,
    transform: "translate(9.131 12.481)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3796",
    "data-name": "Rectangle 3796",
    width: 2.043,
    height: 2.043,
    transform: "translate(9.131 17.928)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3797",
    "data-name": "Rectangle 3797",
    width: 2.043,
    height: 2.724,
    transform: "translate(9.131 24.738)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3798",
    "data-name": "Rectangle 3798",
    width: 2.043,
    height: 2.724,
    transform: "translate(9.131 29.504)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22776",
    "data-name": "Path 22776",
    d: "M161.5,192h8.979a1.5,1.5,0,0,1,0,2.993H161.5a1.5,1.5,0,0,1,0-2.993",
    transform: "translate(-145.035 -174.041)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22777",
    "data-name": "Path 22777",
    d: "M161.5,256h2.993a1.5,1.5,0,0,1,0,2.993H161.5a1.5,1.5,0,1,1,0-2.993",
    transform: "translate(-145.035 -232.055)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "checkbox",
    id: "Group_23812",
    "data-name": "Group 23812"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22773",
    "data-name": "Path 22773",
    d: "M250.938,237.469A13.469,13.469,0,1,1,237.469,224a13.469,13.469,0,0,1,13.469,13.469",
    transform: "translate(-203.049 -203.048)",
    fill: "#699dee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22774",
    "data-name": "Path 22774",
    d: "M302.654,332.286l-2.9-2.9a1.5,1.5,0,1,1,2.116-2.116l.97.968,6.778-5.649a1.5,1.5,0,1,1,1.917,2.3Z",
    transform: "translate(-271.32 -292.098)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplicationStatusCheckIcon);
export default __webpack_public_path__ + "static/media/application-status-check-icon.13b386d8f5ddde19dddbc54c9c0ed5c1.svg";
export { ForwardRef as ReactComponent };